import { createFileRoute } from "@tanstack/react-router";
import SaintVsSpravatoPage from "@/pages/learn/SaintVsSpravatoPage";
import { pageSaintVsSpravato } from "@/pages/learn/learnDataSaintVsSpravato";

export const Route = createFileRoute("/learn/saint-vs-spravato")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: pageSaintVsSpravato.title,
        },
        {
          name: "description",
          content: pageSaintVsSpravato.description,
        },
        {
          property: "og:title",
          content: pageSaintVsSpravato.title,
        },
        {
          property: "og:description",
          content: pageSaintVsSpravato.description,
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/learn/saint-vs-spravato",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/saint-vs-spravato",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(pageSaintVsSpravato.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintVsSpravatoPage />;
}
